import React, { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { Accordion, Button, Card, Col, Container, Image, ListGroup, Row } from 'react-bootstrap';
import { AllInOneHRMS, HrManagementData, KeyBenefits, RevolutionizeYourHR,UnmatchedFeatures,ElevateHR, ReadyToTransform, FaqAdvertise, ElevateHrManagement, SimplifyingHR, FieldEmployeeTracking } from './HrManagementData';
import ClientLogoScroll from '../../../components/ClientLogoScroll/ClientLogoScroll';
import { CustomersData } from '../../../Pages/Customers/CustomersData';
import TabsScrollAd from '../TabsScrollAd/TabsScrollAd';
import ImagesUrl from '../../../assets/Index';
import StarRating from '../../../components/StarRating/StarRating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck, faRemove } from '@fortawesome/free-solid-svg-icons';
import RouteSpecificMeta from '../../../utility/Seo/RouteSpecificMeta';
import HrManagementFooter from '../shared/HrManagementFooter/HrManagementFooter';
import RequestForm from '../../../components/RequestForm/RequestForm';
import ModalForm from '../../../components/ModalForm/ModalForm';
import "./HrManagement.scss";



export const HrManagement = () => {

  const locationUrls = useLocation();
  const pageUrls  = `${window.location.origin}${locationUrls.pathname}`;

  const socialImage = ImagesUrl.QkrbizOgurl;
  // console.log('imgUrl', socialImage);

  const [FormModal, setFormModal] = useState(false);

  const handleClose = () => {
    setFormModal(false);
  };
  const handleShow = () => {
    setFormModal(true);
  };

  const [clientRatings, setClientRatings] = useState(ElevateHR);
  const handleRating = (index, newRating) => {
    setClientRatings((prevRatings) =>
      prevRatings.map((client, i) =>
        i === index ? { ...client, ratings: newRating } : client
      )
    );
  };

  const [openItemAccordion, setOpenItemAccordion] = useState(null);
  const [clickedItemAccordion, setClickedItemAccordion] = useState(null);

  const handleMouseEnter = (key) => {
    if (!clickedItemAccordion) setOpenItemAccordion(key);
  };
  const handleMouseLeave = () => {
    if (!clickedItemAccordion) setOpenItemAccordion(null);
  };
  const handleClick = (key) => {
    setClickedItemAccordion((prev) => (prev === key ? null : key));
    setOpenItemAccordion((prev) => (prev === key ? null : key));
  };

  const employeeCard = {
		arrows:false,
	  centerMode: true,
		centerPadding: "0px",
		slidesToShow: 1,
		slidesToScroll: 1,
		focusOnSelect: true,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,

		responsive: [
		  {
			breakpoint: 768,
			SalesOrder: {
			  slidesToShow: 1,
			},
		  },
		  {
			breakpoint: 480,
			SalesOrder: {
			  slidesToShow: 1,
			},
		  },
		],
	};
  
  const readyTransform = {
		arrows:true,
		centerMode: true,
		centerPadding: "0px",
		slidesToShow: 1,
		slidesToScroll: 1,
		focusOnSelect: true,
    autoplay: false,
		// autoplay: true,
		// autoplaySpeed: 5000,
		dots: false,
		responsive: [
		  {
			breakpoint: 768,
			SalesOrder: {
			  slidesToShow: 1,
			},
		  },
		  {
			breakpoint: 480,
			SalesOrder: {
			  slidesToShow: 1,
			},
		  },
		],
	};
  

  return (
    <>
      <RouteSpecificMeta
      title="Smart HR Software | Simplify Employee Management"
      description="Powerful HR software that automates employee tracking, simplifies compliance, and transforms people management with one-click, zero-complexity solutions."
      canonical={pageUrls}
      image={socialImage}
      SchemaData=""  
      />

      <div className="hr-management hr-landing-bg bg-gray">
            <Container>
              {HrManagementData.map((TeamList, TeamIndex )=>(
                  <Row className="justify-content-between align-items-center w-height" key={TeamIndex}>
                      <Col lg={7}>
                            <h1 className="text-magenta fn-m">{TeamList.title}</h1>
                            <h2 rel="preload"><span dangerouslySetInnerHTML={{ __html: TeamList.subTitle.replaceAll("className='", "class='") }}></span></h2>
                            
                            <ul className="ul-icon mb-0">
                              {TeamList.headList.map((inList, inIndex)=>(
                                <li key={inIndex} className="tick-icon-white-new fn-3" rel="preload"><span dangerouslySetInnerHTML={{ __html: inList.li.replaceAll("className='", "class='") }}></span></li>
                              ))}  
                            </ul>

                            <Row className="justify-content-between align-items-center">
                                <Col lg={11} xl={9} xxl={8}>
                                    <ListGroup horizontal className="heading-mid-top">
                                        {TeamList.reting.map((reting, index)=>(
                                            <ListGroup.Item key={index}>
                                              <Image src={reting.imgUrl} alt={reting.desc} className={reting.cls} />
                                            </ListGroup.Item>
                                        ))} 
                                    </ListGroup>
                                </Col>
                            </Row>
                      </Col>
                      <Col lg={5}>
                        <Card>
                          <Card.Body>
                              <h3 className="fn-sb text-center"><span className="text-magenta">Smart HR </span> for Smarter Decisions</h3>
                              <RequestForm variant="magenta" textCenter="text-center" btnClass="rounded-pill" />
                          </Card.Body>
                        </Card>
                      </Col>
                  </Row>
              ))}
          </Container>
      </div> 

      <ClientLogoScroll ClientLogo={CustomersData} arrows={false} hide={true} show={false} count1={5} count2={3} count3={2} count4={2} count5={1} logoSlider="logo-scroll logo-slider hr-logo-slider" />

      <TabsScrollAd TabScrollData={AllInOneHRMS} colCls1="col-lg-12 col-xl-12 col-xxl-12" colCls2="col-lg-12 col-xl-11 col-xxl-10" addCls="tabscroll-hr advertisement" count1={4} count2={4} count3={3} count4={2} count5={2} count6={1}/>

      <div className="simplifying-hr">
          <Container>
            <Row className='justify-content-between align-items-center'>
              <Col lg={4}>
                <div className="hero">
                  <div className="hero-content">
                    <h2>
                      {SimplifyingHR.hero.title.main}{' '}
                      <span dangerouslySetInnerHTML={{ __html: SimplifyingHR.hero.title.highlight.replaceAll("className='", "class='") }}></span>
                    </h2>
                    <p className="subtitle">
                      {SimplifyingHR.hero.subtitle}
                    </p>
                    <Button variant="pink" onClick={handleShow} className="rounded-pill fn-3 mb-4">{SimplifyingHR.hero.ctaButton.text}</Button>
                  </div>
                </div>
              </Col>
              <Col lg={8}>
                <Row className="features">
                    {SimplifyingHR.features.map((feature, index) => (
                        <Col key={index} lg={6} xl={4} xxl={4}>
                          <div className={feature.className}>
                            <div className="card-header">
                              <div className="icon">
                                <span className={feature.icon}> </span>
                              </div>
                              <h2 className="card-title">{feature.type}</h2>
                            </div>
                            <ul className="feature-list">
                              {feature.items.map((item, itemIndex) => (
                                <li key={itemIndex}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </Col>
                    ))}
                </Row>
              </Col>
            </Row>
          </Container>
      </div>

      <div className="field-workforce">
        <Container>
          {FieldEmployeeTracking.map((field, index)=>(
             <Row key={index}>
                <Col lg={4} className="text-center">
                    <p className='mb-0 fn-3'><span className='text-pink'>{field.title}</span></p>
                    <h2 className='fn-sb'>{field.heading}</h2>
                    <p className="subtitle">{field.description}</p>
                    <Button variant="pink" className="rounded-pill fn-3 mb-4"  onClick={handleShow}>Request Demo</Button>
                </Col>
                <Col lg={8}>
                  <Image fluid src={field.imgUrl} alt="Field Employee Tracking" />
                </Col>
            </Row>
          ))}
        </Container>
     </div>

      <Container className="elevate-management">
          <h2 className="text-center fn-sb">Elevate Your<span className="text-pink"> HR Management</span></h2>
          <Accordion activeKey={openItemAccordion} flush>
            <Row>
              {Array(2)
                .fill()
                .map((_, colIndex) => (
                  <Col lg={6} key={colIndex}>
                    {ElevateHrManagement.slice(colIndex * 3, colIndex * 3 + 3).map((Accorlist, index) => {
                      const uniqueKey = colIndex * 3 + index;
                      return (
                        <Accordion.Item eventKey={uniqueKey} key={uniqueKey}>
                          <Accordion.Header
                            onMouseEnter={() => handleMouseEnter(uniqueKey)}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => handleClick(uniqueKey)}
                          >
                            <Row className="mb-3">
                              <Col lg={12}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0">
                                    <FontAwesomeIcon icon={faRemove} />
                                  </div>
                                  <div className="flex-shrink-1 px-2 text-light">{Accorlist.problem}</div>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={12}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0">
                                    <FontAwesomeIcon icon={faCheck} />
                                  </div>
                                  <div className="flex-shrink-1 px-2 text-info">{Accorlist.solution}</div>
                                </div>
                              </Col>
                            </Row>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>{Accorlist.description}</p>
                            <p className="text-info">{Accorlist.benefit}</p>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Col>
                ))}
            </Row>
          </Accordion>
          {/* <Row className="text-center mt-3">
                <Col lg={12} xl={12}>
                    <Button variant="pink" onClick={handleShow} className="rounded-pill fn-3 ">Get a Demo</Button>
                </Col>
          </Row> */}
      </Container>

     <div className="revolutionize-hr bg-magenta-dark-light">
          <Container>
              {RevolutionizeYourHR.map((list, index)=>(
                <Fragment key={index}>
                    <Row className='justify-content-center align-items-center text-center'>
                      <Col lg={10} xl={7}>
                          <h2 className='text-pink'><span dangerouslySetInnerHTML={{ __html: list.title.replaceAll("className='", "class='") }}/></h2>
                          <p className='fn-4 mb-4'>{list.desc}</p>
                          <Button variant="pink" onClick={handleShow} className="rounded-pill fn-3 ">Learn More</Button>
                      </Col>
                    </Row>  
                    <Row className="justify-content-center align-items-center text-center mt-5">
                      <Col lg={9} xl={8} xxl={7}>
                            <ListGroup horizontal className="heading-mid-top heading-mid-bottom bg-magenta">
                                {list.AllClients.map((text, index)=>(
                                  <ListGroup.Item key={index}>
                                    <h3 className="mb-0 fn-7 text-white">{text.title}</h3>
                                    <p className="mb-0 text-white">{text.desc}</p>
                                  </ListGroup.Item>
                                ))} 
                          </ListGroup>
                      </Col>
                    </Row>
                </Fragment>
              ))} 
          </Container>
     </div>

      <div className="Key-benefits">
          <Container>
              {KeyBenefits.map((keytext, kryIndex) => (
                <Fragment key={kryIndex}>
                  <h2 className="text-center fn-sb"><span dangerouslySetInnerHTML={{ __html:keytext.head.replaceAll("className='", "class='") }}></span></h2>
                  <Row>
                      <Col lg={12} xl={10} xxl={10}>
                          <Row className='row-space-1'>
                            {keytext.keyCard.map((cardtext, cardIndex) => (
                              <Col lg={6} xl={4} key={cardIndex}>
                                <Card>
                                  <Card.Body>
                                    <Image
                                      className="head-icon"
                                      src={cardtext.imgUrl}
                                      alt={cardtext.title || "Card Image"}
                                    />
                                    <h3>{cardtext.title}</h3>
                                    <ul>
                                      {cardtext.listing.map((item, index) => (
                                        <li key={index}>{item}</li>
                                      ))}
                                    </ul>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                      </Col>
                  </Row>
                </Fragment>
              ))}
          </Container>
      </div>

      <div className="elevate-hr slick-slider-dots">
            <Container>
                <Slider {...employeeCard}>
                    {clientRatings.map((clientText, cIndex)=>(
                        <Fragment key={cIndex}>
                            <Row className="justify-content-between align-items-center">
                                <Col lg={6} xl={6} xxl={6} className="text-center">
                                  <h2 className="text-pink">{clientText.title}</h2>
                                  <h3>{clientText.subTitle}</h3>
                                  <Button variant="pink" onClick={handleShow} className="rounded-pill fn-3 mb-5">Join the HR Revolution</Button>
                                </Col>
                                <Col lg={6} xl={6} xxl={4}>
                                    <Card>
                                      <Card.Body>
                                          <p className="text-center mb-1">{clientText.desc}</p>
                                          <div className="d-flex" href="/">
                                              <div className="flex-shrink-0">
                                                <img src={clientText.imgUrl} alt={clientText.clientName} />
                                              </div>
                                              <div className="flex-grow-1">
                                                <h4 className="text-magenta mb-0">{clientText.clientName}</h4>                                    
                                                <p className="fn-1 mb-0">{clientText.companyName}</p>
                                                <StarRating cls="text-left" totalStars={5} rating={clientText.ratings}  onRate={(newRating) => handleRating(cIndex, newRating)} />
                                              </div>
                                          </div>
                                      </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Fragment>
                    ))}
                </Slider>
            </Container>
      </div>

      <div className="unmatched-Features">
          <Container>
              <Row  className="justify-content-center">
                  <Col lg={12} xl={12} xxl={11}>
                      {UnmatchedFeatures.map((fText, fIndex)=>(
                          <Fragment key={fIndex}>
                              <h2 className="fn-sb text-center mb-5"><span dangerouslySetInnerHTML={{ __html: fText.title.replaceAll("className='", "class='") }}/></h2>
                              <Row>
                                  {fText.AllClients.map((list, index)=>(
                                      <Col lg={4} key={index}>
                                          <div className={`d-flex align-items-center ${list.cls}`}>
                                                <div className="flex-shrink-0">{list.desc}</div>
                                                <div className="flex-grow-1">{list.title}</div>
                                          </div>   
                                      </Col>
                                  ))}
                              </Row>
                          </Fragment>
                      ))}
                  </Col>
              </Row>
          </Container>
      </div>  

      <div className="slick-slider-dots hr-operations">
          <Container>
                <Slider {...readyTransform}>
                    {ReadyToTransform.map((readyText, rIndex)=>(
                        <Fragment key={rIndex}>
                          <Row className="justify-content-justify align-items-center">
                              <Col lg={6} xl={6} className='order-lg-1 order-2'>
                                  <Image fluid src={readyText.imgUrl} alt="eady to Transform Your HR Operations" />
                              </Col>

                              <Col lg={6} xl={6} className="pt-5 pt-lg-0 pb-3 pb-lg-0 mb-2 order-lg-2 order-1">
                                    <h2 className="mb-2 fn-sb"> <span dangerouslySetInnerHTML={{ __html: readyText.title.replaceAll("className='", "class='") }}/></h2>
                                    <p className="fn-4 mt-3 mb-5">{readyText.desc}</p>
                                    <Button variant="pink" onClick={handleShow} className="rounded-pill fn-3">Schedule a Free Demo</Button>

                              </Col>
                          </Row>
                        </Fragment>                          
                    ))}
              </Slider>
          </Container>
      </div>
      
      <div className="hrms-faq bg-white hr-faq-add">
            <Container>
                {FaqAdvertise.map((items, indexs)=>(
                    <Fragment key={indexs}>
                        <div className="heading-title text-center mt-4">
                          <h2 className="under-line mb-2">{items.title}</h2>
                          <p className='text-center fn-4 faq-p'><span dangerouslySetInnerHTML={{__html:items.desc.replace("className='", "class='")}}></span></p> 
                        </div>
                        <Accordion>
                          <div className="row justify-content-center item-aligns-top">
                            <div className="col-lg-6">
                                {items.List.map((item, index)=> (
                                  <Fragment key={index}> 
                                    {index % 2 === 0 && (
                                      <Accordion.Item eventKey={index.toString()} >
                                        <Accordion.Header as="h3">{item.title}</Accordion.Header>
                                        <Accordion.Body><div dangerouslySetInnerHTML={{__html:item.desc.replaceAll("className='", "class='")}}></div></Accordion.Body>
                                      </Accordion.Item>		
                                    )}
                                  </Fragment>
                                ))}
                            </div>
                            <div className="col-lg-6">
                                {items.List.map((item, index)=> (
                                  <Fragment key={index}> 
                                    {index % 2 !== 0 && (
                                      <Accordion.Item eventKey={index.toString()} >
                                        <Accordion.Header as="h3">{item.title}</Accordion.Header>
                                        <Accordion.Body><div dangerouslySetInnerHTML={{__html:item.desc.replaceAll("className='", "class='")}}></div></Accordion.Body>
                                      </Accordion.Item>
                                    )}
                                  </Fragment>
                                ))}
                            </div>
                          </div>
                        </Accordion>
                    </Fragment>
                ))}
            </Container>
      </div> 

      <ModalForm show={FormModal} handleClose={handleClose}></ModalForm>
      <HrManagementFooter />

    </>
  )
}
